var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { rankWith, uiTypeIs, } from '@jsonforms/core';
import { ResolvedJsonFormsDispatch, useJsonForms, withJsonFormsLayoutProps } from '@jsonforms/react';
import { withVanillaControlProps } from '@jsonforms/vanilla-renderers';
export var noLayoutTester = rankWith(1, uiTypeIs('NoLayout'));
export var NoLayoutRenderer = function (props) {
    var _a;
    var uischema = props.uischema, schema = props.schema, path = props.path, visible = props.visible, renderers = props.renderers;
    var cells = useJsonForms().cells;
    var layoutProps = {
        elements: uischema.elements,
        schema: schema,
        path: path,
        direction: 'column',
        visible: visible,
        uischema: uischema,
        renderers: renderers,
    };
    return (_jsx("fieldset", __assign({ className: "form-group col col-12 col-md-12 show" }, { children: _jsxs("div", __assign({ className: "fields row" }, { children: [_jsxs("legend", { children: ["Behandler ", ((_a = layoutProps.uischema.iteration) !== null && _a !== void 0 ? _a : 0) + 1] }), layoutProps.elements.map(function (child, index) { return (_jsx(ResolvedJsonFormsDispatch, { renderers: renderers, cells: cells, uischema: child, schema: schema, path: path }, index)); })] })) })));
};
// eslint-disable-next-line import/no-default-export
export default withVanillaControlProps(withJsonFormsLayoutProps(NoLayoutRenderer));
